import { format, isValid, parseISO } from "date-fns";
import {
  MEMBERSHIP_LIST_COLUMN_DEFS,
  MEMBERSHIP_LIST_COLUMN_VISIBILITY_KEY,
} from "./membershipListConstants";

export function loadMembershipListSavedVisibility() {
  try {
    const raw = localStorage.getItem(MEMBERSHIP_LIST_COLUMN_VISIBILITY_KEY);
    if (raw) return JSON.parse(raw);
  } catch {
    // ignore
  }
  return null;
}

export function isTruthy(v) {
  return v === true || v === 1 || v === "1";
}

export function formatDateCell(value, withTime = false) {
  if (!value) return "—";
  try {
    const raw = String(value).trim();
    let d = parseISO(raw);
    if (!isValid(d) && /^\d{4}-\d{2}-\d{2}/.test(raw)) d = new Date(raw.replace(" ", "T"));
    if (!isValid(d)) d = new Date(raw);
    if (!isValid(d)) return "—";
    return format(d, withTime ? "PPp" : "PP");
  } catch {
    return "—";
  }
}

export function formatMoney(v) {
  if (v == null || v === "") return "—";
  const n = Number(v);
  return Number.isFinite(n) ? `₹${n.toFixed(2)}` : "—";
}

export function membershipCellValue(id, row) {
  if (id === "start_date" || id === "end_date" || id === "payment_date") return formatDateCell(row[id]);
  if (id === "submitted_at" || id === "approved_at") return formatDateCell(row[id], true);
  if (id === "amount") return formatMoney(row[id]);
  return row[id] ?? "—";
}

export function membershipSortValue(row, id) {
  if (id === "application_verified" || id === "payment_verified") return isTruthy(row[id]) ? 1 : 0;
  if (id === "amount") return Number(row[id] || 0);
  if (id === "start_date" || id === "end_date" || id === "payment_date" || id === "submitted_at" || id === "approved_at") {
    const t = new Date(row[id] || 0).getTime();
    return Number.isFinite(t) ? t : 0;
  }
  return String(row[id] ?? "").toLowerCase();
}

export function createInitialMembershipColumnVisibility() {
  const saved = loadMembershipListSavedVisibility();
  const initial = {};
  for (const c of MEMBERSHIP_LIST_COLUMN_DEFS) {
    initial[c.id] = saved?.[c.id] ?? c.defaultVisible;
  }
  return initial;
}
